import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Category from './Category'

const takeBrandsFromProducts = R.pipe(
  R.defaultTo([]),
  R.map(R.path(['node', 'template', '0', 'brand'])),
  R.reject(R.isNil),
  R.uniq
)

const HireCategory = ({ category, products }) => (
  <section>
    <Category category={category} data={products} filters={takeBrandsFromProducts(products)} />
  </section>
)

HireCategory.propTypes = {
  products: PropTypes.array.isRequired,
  category: PropTypes.string
}

export default HireCategory



// WEBPACK FOOTER //
// ./src/components/HireCategory/HireCategory.js